import { getBlock } from "../service/getBlock";
import { IProduct } from "../views/ecommerce/products/interfaces";

export const getProducts = async (
    login: any,
    setProduct: (product: IProduct[]) => void,
    setPage: (page: number) => void,
    setMaxPage: (page: number) => void
): Promise<{
    isError: boolean,
    loading: boolean
}> => {
    const { block, isError, loading} = await getBlock("/branch/products", {
        bid: login.user.branchsId,
    });

    setProduct(block.Apis);
    setPage(block.page);
    setMaxPage(block.pageCount);

    return {
        isError: isError,
        loading: loading
    }
}